import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading, UitkText } from "uitk-react-text";
import { HotelRecentReviewsFlexModuleResult } from "typings/microserviceModels/hotel-recent-reviews-flex-module";

const HeaderImageCardModuleTitle = (props: { model: HotelRecentReviewsFlexModuleResult }) => {
  const { title, showSubtitleForHeaderImageView, brandName } = props.model;
  const { formatText } = useLocalization();

  return (
    <>
      <UitkHeading tag="h2" size={4}>
        {title}
        {showSubtitleForHeaderImageView && (
          <UitkText size={300} weight="regular">
            {formatText("hotelRecentReviews.brandVerifiedReviews", brandName)}
          </UitkText>
        )}
      </UitkHeading>
    </>
  );
};

export default HeaderImageCardModuleTitle;
